var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5L6.78 6.79L8.5 6L6.78 5.22L6 3.5L5.215 5.22L3.5 6L5.215 6.79L6 8.5ZM4.085 1.38C4.69254 1.12997 5.34303 1.0009 6 1C6.655 1 7.305 1.13 7.915 1.38C8.52 1.63 9.07 2 9.535 2.465C10 2.93 10.37 3.48 10.62 4.085C10.87 4.695 11 5.345 11 6C11 7.325 10.475 8.6 9.535 9.535C9.07124 9.9999 8.52024 10.3686 7.9136 10.62C7.30697 10.8714 6.65666 11.0006 6 11C5.34303 10.9991 4.69254 10.87 4.085 10.62C3.47888 10.3684 2.92836 9.99972 2.465 9.535C2.0001 9.07124 1.63137 8.52023 1.37996 7.9136C1.12856 7.30697 0.999433 6.65666 1 6C1 4.675 1.525 3.4 2.465 2.465C2.93 2 3.48 1.63 4.085 1.38ZM3.17 8.83C3.92 9.58 4.94 10 6 10C7.06 10 8.08 9.58 8.83 8.83C9.58 8.08 10 7.06 10 6C10 4.94 9.58 3.92 8.83 3.17C8.07896 2.42042 7.0611 1.9996 6 2C4.94 2 3.92 2.42 3.17 3.17C2.42042 3.92104 1.99961 4.9389 2 6C2 7.06 2.42 8.08 3.17 8.83Z",
    fill: "#DDAE07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.ae0aaacaf9c8ba7fa8c716833e2df27c.svg";
export { ForwardRef as ReactComponent };